import { Row } from '@/components/grid/grid-component';
import ReactPhoneInput from 'react-phone-number-input';
import styled from 'styled-components';

const Div = styled.div`
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-top: auto;
  width: 100%;
`;

const PhoneNumberContainer = styled.div`
  display: flex;
`;

const RowStyle = styled(Row)`
  width: 100% !important;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK} !important;
  margin-bottom: 25px !important;
  padding: 24px !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
  justify-content: end !important;
`;

const Main = styled.div`
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  min-height: 100%;
  justify-content: center;
  width: 100%;
`;

const DivStyle = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const PhoneInput = styled(ReactPhoneInput)`
  .PhoneInputInput {
    display: none;
  }

  .PhoneInputCountrySelectArrow {
    display: none;
  }

  .PhoneInput-color--focus {
    border-color: #eaedf3;
  }

  .PhoneInputCountryIconImg {
    border-radius: 4px;
  }

  .PhoneInputCountryIcon--border {
    border: none;
    border-radius: 4px;
    background-color: #eaedf3;
  }

  .PhoneInputCountry {
    display: flex;
    justify-content: center;
    border-radius: 4px 0 0 4px;
    margin: 0;
    border-right: none;
    margin-right: 6px;
  }
`;

const GoBack = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;
const Span = styled.span`
  display: flex;
  align-items: center;

  .title {
    margin: 0 16px 0 0;
  }
`;

const StyledRow = styled(Row)`
  padding: 0 16px;
`;

const StyledDiv = {
  Div,
  RowStyle,
  Main,
  DivStyle,
  PhoneInput,
  PhoneNumberContainer,
  GoBack,
  Span,
  StyledRow,
};

export default StyledDiv;
